import CompanyLogo from './_company_logo';

import classNames from 'classnames';

const DigestCompetitors = ({rivals, selectedRivalId, defaultRival, storyCount, className, showPrefix, onClickRival}) => {
  if(_.isEmpty(rivals)) {
    return null;
  }

  const rivalIsHighlighted = rival => {
    const {id} = rival;

    return (selectedRivalId === id) || (!selectedRivalId && defaultRival && (defaultRival.id === id));
  };

  const competitorNodes = rivals.map(rival => {
    if(!_.isEmpty(rival)) {
      const {id, name, profile, isDraft} = rival;
      const {isDraft: profileIsDraft} = profile || {};
      const isHighlighted = rivalIsHighlighted(rival);

      return (
        <span
          key={`competitor_${id}`}
          onClick={e => !isHighlighted && onClickRival && onClickRival(e, id)}
          data-testid={`digest-competitor_${id}`}
          className={
            classNames('tag',
              {
                'tag--highlighted': isHighlighted,
                'tag--noHover': Boolean(!onClickRival),
                'tag--draft': Boolean(isDraft || profileIsDraft)
              }
            )
          }>
          <CompanyLogo
            rival={rival}
            className="avatar logo tag-image" />
          <span className="tag-text">{name}</span>
        </span>
      );
    }
  });

  const digestItemClass = classNames('tags', {
    [className]: Boolean(className)
  });

  return (
    <div key="digestTags" className={digestItemClass}>
      {showPrefix &&
        <span className="digest-competitors_text">
          {`${storyCount} stor${storyCount === 1 ? 'y' : 'ies'}${rivals.length ? ' featuring:' : ''}`}
        </span>
      }
      {competitorNodes}
    </div>
  );
};

DigestCompetitors.contextTypes = {
  utils: PropTypes.object.isRequired
};

DigestCompetitors.propTypes = {
  rivals: PropTypes.arrayOf(PropTypes.object),
  selectedRivalId: PropTypes.number,
  defaultRival: PropTypes.object,
  storyCount: PropTypes.number,
  className: PropTypes.string,
  showPrefix: PropTypes.bool,
  onClickRival: PropTypes.func
};

DigestCompetitors.defaultProps = {
  rivals: [],
  selectedRivalId: null,
  defaultRival: null,
  storyCount: 0,
  className: '',
  showPrefix: true,
  onClickRival: null
};

export default DigestCompetitors;
